import React from 'react';
import {Box, Button, MenuItem, Select} from '@mui/material';
import Typography from '@mui/material/Typography';
import {useMutation, useQuery} from '@apollo/client';
import {groupBy} from 'lodash-es';
import {getBusinessUnitsQuery, useDjangoContext} from '../../contexts/useAuthContext';
import {
  SwitchBusinessUnit,
  SwitchBusinessUnitVariables,
} from '../../schema-types/SwitchBusinessUnit';
import {GetBusinessUnits} from '../../schema-types/GetBusinessUnits';
import {SaltusAny} from '../../utils/SaltusAny';
import {GET_LOGIN_INFO_QUERY} from '../../hooks/useDjango';
import {switchBusinessUnitMutation} from './AdminDialog';

export const ChangeBusinessUnit: React.FC<{
  type: 'dropdown' | 'buttons';
  onClose?: () => void;
}> = ({type, onClose: _onClose}) => {
  const {djangoUser, businessUnit} = useDjangoContext();
  const [_switchBusinessUnit] = useMutation<
    SwitchBusinessUnit,
    SwitchBusinessUnitVariables
  >(switchBusinessUnitMutation);
  const {data} = useQuery<GetBusinessUnits>(getBusinessUnitsQuery);
  const switchBusinessUnit = (businessUnitId: string) => {
    if (djangoUser.id) {
      if (
        process.env.NODE_ENV === 'development' &&
        djangoUser.businessUnit?.id === businessUnitId
      ) {
        return;
      }
      _switchBusinessUnit({
        variables: {
          staffId: djangoUser.id,
          businessUnitId,
        },
        refetchQueries: [GET_LOGIN_INFO_QUERY],
      });
    }
  };
  const businessUnitsGrouped = groupBy(data?.businessUnits || [], 'partnershipType');

  return (
    <>
      <Typography variant="h5">
        <strong>Change business unit:</strong>
      </Typography>
      {type === 'dropdown' ? (
        <Select
          // placeholder="Select action"
          onChange={(e: SaltusAny) => {
            switchBusinessUnit(e.target.value);
            setTimeout(() => {
              window.location.reload();
            }, 500);
          }}
          value={businessUnit?.id}
        >
          {data?.businessUnits?.map((x) => {
            return (
              <MenuItem key={x!.id} value={x?.id}>
                {x?.name}
              </MenuItem>
            );
          })}
        </Select>
      ) : (
        <Box mt={1}>
          {Object.keys(businessUnitsGrouped).map((group) => {
            return (
              <Box mb={1} key={group}>
                <Typography>{group}</Typography>
                <Box display="flex" flexWrap="wrap" gap={1}>
                  {businessUnitsGrouped[group]?.map((x) => {
                    return (
                      <Button
                        color={x?.id === businessUnit.id ? 'secondary' : 'primary'}
                        variant="contained"
                        size="small"
                        key={x!.id}
                        onClick={(e) => {
                          switchBusinessUnit(String(x?.id));
                          if (e.altKey) {
                            // do nothing
                          } else {
                            setTimeout(() => {
                              window.location.reload();
                            }, 500);
                          }
                        }}
                      >
                        {x?.name}
                      </Button>
                    );
                  })}
                </Box>
              </Box>
            );
          })}
        </Box>
      )}
    </>
  );
};
